// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateWarrantyExpirationAccountsCriteria = (dealer, isSelected) => ({
    dealer,
    isSelected,
    type: actions.UPDATE_WARRANTY_EXPIRATION_ACCOUNTS_CRITERIA
});

export const updateWarrantyExpirationTypesCriteria = (warrantyType, isSelected) => ({
    isSelected,
    type: actions.UPDATE_WARRANTY_EXPIRATION_WARRANTY_TYPES,
    warrantyType
});

export const updateWarrantyExpirationDateCriteria = expirationDateRange => ({
    expirationDateRange,
    type: actions.UPDATE_WARRANTY_EXPIRATION_EXPIRATION_DATE
});

export const warrantyExpirationSelectAllAccountsCriteria = dealers => ({
    dealers,
    type: actions.WARRANTY_EXPIRATION_SELECT_ALL_ACCOUNTS_CRITERIA
});

export const warrantyExpirationSelectAllTypesCriteria = () => ({
    type: actions.WARRANTY_EXPIRATION_SELECT_ALL_TYPES_CRITERIA
});

export const updateAllDealersOnLoad = dealers => ({
    dealers,
    type: actions.WARRANTY_EXPIRATION_SELECT_ALL_ACCOUNTS_ON_LOAD
});

export const resetWarrantyExpirationCriteria = dealers => ({
    dealers,
    type: actions.RESET_WARRANTY_EXPIRATION_CRITERIA
});



// WEBPACK FOOTER //
// ./src/reports/warranty-expiration/action-creators/criteria.js